// Provides bridging from our client to us.
// For example, if an Android client is using the web builder in a web view,
// Android can use the global functions here to send us messages.

import Vue from 'vue';

const BackButtonEventBus = new Vue();
const ClosetDataLoadedEventBus = new Vue();
const OutfitSharingMenuLoadedEventBus = new Vue();
const SetSelfieEventBus = new Vue();
const SaveFailedEventBus = new Vue();
const BuilderIsFocusedBus = new Vue();

const OUTFIT_SHARE_LOADED_ACTION = 'outfitShareLoaded';
const CLOSET_LOADED_ACTION = 'closetDataLoaded';
const SET_SELFIE_ACTION = 'setSelfie';
const SAVE_FAILED_ACTION = 'saveFailed';

// Important: The webview consumer has to be compatible with interface changes here
// The client can call this, for example, when back button on Android is pressed.
global.backButtonPress = () => {
  BackButtonEventBus.$emit('pressed');
};

global.closetDataLoaded = (data, error) => {
  ClosetDataLoadedEventBus.$emit('loaded', data, error);
};

global.outfitShareLoaded = (isDeprecated, error) => {
  OutfitSharingMenuLoadedEventBus.$emit('loaded', isDeprecated, error);
};

// Important: The webview consumer has to be compatible with interface changes here
global.setSelfie = (data) => {
  SetSelfieEventBus.$emit('set', data);
};

// Important: The webview consumer has to be compatible with interface changes here
global.saveFailed = (failureReason) => {
  SaveFailedEventBus.$emit('failed', failureReason);
};

// Handle actions via window.postMessage
window.addEventListener('message', (event: MessageEvent) => {
  switch (event.data.action) {
    case CLOSET_LOADED_ACTION:
      global.closetDataLoaded!(event.data.message, event.data.error);
      break;
    case SET_SELFIE_ACTION:
      global.setSelfie!(event.data.message);
      break;
    case SAVE_FAILED_ACTION:
      global.saveFailed!(event.data.message);
      break;
    case OUTFIT_SHARE_LOADED_ACTION:
      global.outfitShareLoaded!(event.data.message, event.data.error);
      break;
    default:
      console.log(event.data);
  }
});

// Avatar Builder will soon be built into the Snapchat profile screen. Indicate when the builder
//  screen is focused or when it is not focused
global.builderIsFocused = (isFocused) => {
  BuilderIsFocusedBus.$emit('set', isFocused);
};

export default {
  BackButtonEventBus,
  ClosetDataLoadedEventBus,
  OutfitSharingMenuLoadedEventBus,
  SetSelfieEventBus,
  BuilderIsFocusedBus,
  SaveFailedEventBus,
};
